import {inject, Injectable} from '@angular/core';
import {Observable, of, throwError} from 'rxjs';
import {catchError, switchMap, timeout} from 'rxjs/operators';

import {AppApiService} from '@app/core/services/app-api.service';


@Injectable({
  providedIn: 'root'
})
export class ServerTimeService {
  private offset: number = 0;
  private readonly appApiService = inject(AppApiService);

  initSync(): Promise<boolean> {
    return this.appApiService.getUtcNow().pipe(
      timeout(3000),
      switchMap((serverTimeSeconds: number): Observable<boolean> => {
        if (!Number.isFinite(serverTimeSeconds) || serverTimeSeconds <= 0) {
          return throwError(() => new Error('Invalid server timestamp'));
        }

        const serverTimeMs = serverTimeSeconds * 1000;
        this.offset = serverTimeMs - Date.now();

        return of(true);
      }),
      catchError((error): Observable<boolean> => {
        console.warn(error);
        this.offset = 0;
        return of(true);
      })
    ).toPromise().then(result => result ?? true);
  }

  getNow(): Date {
    const correctedTime = new Date().getTime() + this.offset;
    return new Date(correctedTime);
  }
}
